import { all, call, put, takeLatest, takeEvery } from "redux-saga/effects";

import { get, patch } from "redux/fetch";
import { rollbarXHRError } from "lib/rollbar";

import { uiSetAsyncError, uiSetLoading, uiSetSubmitting, showErrorToast } from "redux/ws/actions";

import { positionPatch, positionsFetchSuggestions, positionsSetSuggestions } from "./actions";

/**
 * Adds an answer/response to a question for a user
 */
function* fetchSuggestions({ payload = {} }) {
    yield put(uiSetLoading(true));

    try {
        const data = {};
        if (payload.matches) {
            data.matches = 1;
        }

        const result = yield call(get, "/api/hire/v1/suggestion/", data);

        yield put(positionsSetSuggestions(result));
    } catch (e) {
        rollbarXHRError("Failed to post question", e);
        yield put(uiSetAsyncError("Something went wrong. Please try again."));
    } finally {
        yield put(uiSetLoading(false));
    }
}

function* patchPosition({ payload: { id, ...data } }) {
    yield put(uiSetSubmitting(true));

    try {
        yield call(patch, `/api/hire/v1/position/${id}/`, data);
    } catch (e) {
        rollbarXHRError("Failed to patch position", e, { id, ...data });
        yield put(uiSetAsyncError(true));
        yield put(showErrorToast("Something went wrong. Please try again."));
    } finally {
        yield put(uiSetSubmitting(false));
    }
}

export default function* positionSagas() {
    yield all([
        takeEvery(positionPatch, patchPosition),
        takeLatest(positionsFetchSuggestions, fetchSuggestions),
    ]);
}
